import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
   addDriverMasterApiCall,
   fetchAllContractorsApiCall,
   fetchAllFleetApiCall,
   fetchAllFleetEditApiCall,
   fetchAllUniqueFleetApiCall,
   getDriverRecordByVendorId,
   getLaneMasterApiCall,
   getLaneRecordById,
   listDriverMasterApiCall,
   updateDriverMasterApiCall,
} from "../../Api/api";
import client from "../../Api/client";

// initial state
const initialState = {
   dataList: [],
   total: 0,
   pagination: null,
   singleDriverMaster: null,
   singleVehicleMaster:null,
   uniqueVehicleMaster:null,
   singleEditVehicleMaster:null,
   singleDriverRecordByVendorId:null,
   laneMaster:null,
   contractors: [],
   isLoading: false,
   isError: false,
   isSuccess: false,
};

// add Driver
export const fetchAllContractorsAsync = createAsyncThunk(
   "driverMaster/fetch-contractors-driver",
   async ({ done, err }, thunkAPI) => {
      try {
         const response = await fetchAllContractorsApiCall();
         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);


export const fetchAllFleetAsync = createAsyncThunk(
   "driverMaster/fetch-fleet",
   async ({ done, err }, thunkAPI) => {
      try {
         const response = await fetchAllFleetApiCall();
         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);


export const fetchAllFleetUniqueAsync = createAsyncThunk(
   "driverMaster/fetch-fleet-unique",
   async ({ done, err }, thunkAPI) => {
      try {
         const response = await fetchAllUniqueFleetApiCall();
         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);


export const fetchAllFleetEditAsync = createAsyncThunk(
   "driverMaster/trip-edit-fetch-fleet",
   async ({ done, err }, thunkAPI) => {
      try {
         const response = await fetchAllFleetEditApiCall();
         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);




export const fetchAllLaneAsync = createAsyncThunk(
   "laneMaster/fetch-all-lanes",
   async ({ done, err }, thunkAPI) => {
      try {
         const response = await getLaneMasterApiCall();
         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);


// add fleet
export const addDriverMasterAsync = createAsyncThunk(
   "driverMaster/add-driver-master",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const { data: response } = await addDriverMasterApiCall(data);
         

         if (response?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response?.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error);
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// update fleet
export const updateDriverMasterAsync = createAsyncThunk(
   "driverMaster/update-driver-master",
   async ({ data, done, err }, thunkAPI) => {
      try {
         const { data: response } = await updateDriverMasterApiCall(data);

         if (response?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

// list driver master
export const listDriverMasterAsync = createAsyncThunk(
   "driverMaster/list-driver-master",
   async ({ params, err, done } = {}, thunkAPI) => {
      try {
         const response = await listDriverMasterApiCall(params);

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// fetch single fleet
export const fetchSingleDriveMasterAsync = createAsyncThunk(
   "driverMaster/fetch-single-fleet",
   async ({ id, done, err }, thunkAPI) => {
      try {
         const response = await client.get(`driver/${id}`, {
            headers: {
               Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
            },
         });
         
         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         return thunkAPI.rejectWithValue(error?.response?.data);
      }
   }
);

// fetch driver record by vendor id
export const fetchDriverRecordByVendorIdAsync = createAsyncThunk(
   "driverMaster/get-record-by-vendor-id",
   async ({ id, done, err }, thunkAPI) => {
      
      try {
         const response = await getDriverRecordByVendorId(id);         

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         return thunkAPI.rejectWithValue(error?.response?.data);
      }
   }
);




// fetch lane details record by vendor id
export const fetchLaneRecordByIdAsync = createAsyncThunk(
   "driverMaster/get-record-by-vendor-id",
   async ({ id, done, err }, thunkAPI) => {
      
      try {
         const response = await getLaneRecordById(id);         

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         return thunkAPI.rejectWithValue(error?.response?.data);
      }
   }
);



// fleet master slice
const driverMasterSlice = createSlice({
   name: "driverMaster",

   initialState: initialState,

   reducers: {
      clearDriverMasterState: (state, action) => {
         state.isLoading = false;
         state.isError = false;
         state.isSuccess = false;
      },
   },

   extraReducers: (builder) => {
      //
      builder.addCase(fetchAllContractorsAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(fetchAllContractorsAsync.fulfilled, (state, action) => {
         
         state.isLoading = false;
         state.contractors = action.payload;
      });
      builder.addCase(fetchAllContractorsAsync.rejected, (state, action) => {
         state.isLoading = false;
      });
      //
      builder.addCase(listDriverMasterAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(listDriverMasterAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         const rawList = Array.isArray(action.payload?.res)
            ? action.payload.res
            : Array.isArray(action.payload?.res?.data)
              ? action.payload.res.data
              : Array.isArray(action.payload?.data)
                ? action.payload.data
                : Array.isArray(action.payload)
                  ? action.payload
                  : [];
         state.dataList = rawList;
         state.pagination = action.payload?.pagination || null;
         state.total =
            action.payload?.pagination?.total ??
            (Array.isArray(action.payload?.res)
               ? action.payload.res.length
               : rawList.length);
      });
      builder.addCase(listDriverMasterAsync.rejected, (state, action) => {
         state.isLoading = false;
      });

      //
      builder.addCase(fetchSingleDriveMasterAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(fetchSingleDriveMasterAsync.fulfilled, (state, action) => {
         
         state.isLoading = false;
         state.singleDriverMaster = action.payload;
      });
      builder.addCase(fetchSingleDriveMasterAsync.rejected, (state, action) => {
         state.isLoading = false;
      });


      //
      builder.addCase(fetchDriverRecordByVendorIdAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(fetchDriverRecordByVendorIdAsync.fulfilled, (state, action) => {
         
         state.isLoading = false;
         state.singleDriverRecordByVendorId = action.payload;
      });
      builder.addCase(fetchDriverRecordByVendorIdAsync.rejected, (state, action) => {
         state.isLoading = false;
      });


      // 
      builder.addCase(fetchAllFleetAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(fetchAllFleetAsync.fulfilled, (state, action) => {         
         state.isLoading = false;
         state.singleVehicleMaster = action.payload;
      });
      builder.addCase(fetchAllFleetAsync.rejected, (state, action) => {
         state.isLoading = false;
      }); 



       builder.addCase(fetchAllFleetUniqueAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(fetchAllFleetUniqueAsync.fulfilled, (state, action) => {         
         state.isLoading = false;
         state.uniqueVehicleMaster = action.payload;
      });
      builder.addCase(fetchAllFleetUniqueAsync.rejected, (state, action) => {
         state.isLoading = false;
      }); 


      // 
      builder.addCase(fetchAllFleetEditAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(fetchAllFleetEditAsync.fulfilled, (state, action) => {         
         state.isLoading = false;
         state.singleEditVehicleMaster = action.payload;
      });
      builder.addCase(fetchAllFleetEditAsync.rejected, (state, action) => {
         state.isLoading = false;
      }); 


       
      
      

      //  
      builder.addCase(fetchAllLaneAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(fetchAllLaneAsync.fulfilled, (state, action) => {         
         state.isLoading = false;
         state.laneMaster = action.payload;
      });
      builder.addCase(fetchAllLaneAsync.rejected, (state, action) => {
         state.isLoading = false;
      }); 


   },
});

export const { clearDriverMasterState } = driverMasterSlice.actions;

const driverMasterReducer = driverMasterSlice.reducer;
export default driverMasterReducer;
